'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BRUSH = exports.BRUSH = 'brush';
var LASSO = exports.LASSO = 'lasso';
var INVERSE = exports.INVERSE = 'inverse';
var FREEHAND = exports.FREEHAND = 'freehand';
var RECT = exports.RECT = 'rect';


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/DrawingModes.js
// module id = 52
// module chunks = 0